export const ACTION_RESET_RESULTS = "ACTION_RESET_RESULTS";

export interface ActionResetResult {
  readonly type: typeof ACTION_RESET_RESULTS;
}

export default (): ActionResetResult => ({
  type: ACTION_RESET_RESULTS,
});
